import { type HTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type VisuallyHiddenProps = HTMLAttributes<HTMLSpanElement>;

const VisuallyHidden = ({ className, ...props }: VisuallyHiddenProps) => (
  <span className={cn("sr-only", className)} {...props} />
);

// Shared skip-link treatment for controls that should enter the visual layout
// only when reached from the keyboard.
export const FOCUS_REVEALED_CLASSES =
  "sr-only focus-visible:not-sr-only focus-visible:absolute focus-visible:left-grid-margin focus-visible:top-m focus-visible:z-50 focus-visible:h-auto focus-visible:w-auto focus-visible:rounded-full focus-visible:bg-brand-white focus-visible:px-l focus-visible:py-m focus-visible:text-content-primary";

export default VisuallyHidden;
